var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1277(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.402,
    height: 25.813,
    viewBox: "0 0 29.402 25.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(-1003.778 -429.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(1000.628 427.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2719",
    "data-name": "Group 2719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M20,21.85a.85.85,0,0,1-.85-.85V19A3.154,3.154,0,0,0,16,15.85H8A3.154,3.154,0,0,0,4.85,19v2a.85.85,0,1,1-1.7,0V19A4.855,4.855,0,0,1,8,14.15h8A4.855,4.855,0,0,1,20.85,19v2A.85.85,0,0,1,20,21.85Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    d: "M4-.85A4.85,4.85,0,1,1-.85,4,4.855,4.855,0,0,1,4-.85Zm0,8A3.15,3.15,0,1,0,.85,4,3.154,3.154,0,0,0,4,7.15Z",
    transform: "translate(8 3)",
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276",
    transform: "translate(1016.875 439.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M332.407,260.989a8.153,8.153,0,1,1-8.153-8.153,8.153,8.153,0,0,1,8.153,8.153",
    transform: "translate(-316.102 -252.836)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M398.507,327.5h-2.663v-3a.646.646,0,1,0-1.286,0v3h-2.663a.71.71,0,0,0,0,1.413h2.663v2.859a.646.646,0,1,0,1.286,0v-2.859h2.663a.71.71,0,0,0,0-1.413",
    transform: "translate(-386.812 -319.991)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1277);
export default __webpack_public_path__ + "static/media/Group 1277.21136aa2f2ec105b28bff483d3110f44.svg";
export { ForwardRef as ReactComponent };